// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mg {
  margin-left: 6px;
}

.name {
  font-weight: bold;
  float: left;
}

.badge {
  float: right;
}

.aling-all {
  display: inline-flex;
  align-items: center;
  font-size: 0.8em;
}

.rm-mg {
  margin-left: -80px;
}

.item-chat h2, .item-chat p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-avatar {
  width: 60px;
  height: 60px;
}
.icon-avatar .profile-picture {
  background: var(--bg-color);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  padding: 18px;
}
.icon-avatar .profile-picture .cus-picture {
  width: 24px;
  height: 24px;
}

.new-message-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 10px 0px;
  width: 100%;
}
.new-message-container .chat-title {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}
.new-message-container .user-last-message-name {
  font-size: 16px;
  margin-bottom: 3px;
  font-weight: bold;
}
.new-message-container .user-last-message {
  font-size: 14px;
  margin-bottom: 3px;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.new-message-container .user-last-message-date {
  font-size: 10px;
  opacity: 0.7;
}

.notif {
  width: 13px;
  height: 13px;
  border-radius: 50%;
  color: rgba(255, 255, 255, 0);
}

ion-searchbar {
  --icon-color: rgba(0,0,0,0.6);
  font-family: var(--font);
  font-weight: 400;
  width: 90%;
  margin: auto;
}

.add-new-chat {
  display: none;
}

.container-no-content-chat {
  position: relative;
}
.container-no-content-chat > .wait-content {
  position: absolute;
  top: 15px;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.3rem;
}
.container-no-content-chat ion-icon {
  height: 300px;
  width: 100%;
}
.container-no-content-chat .text-empty-content {
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: auto;
  text-align: center;
  font-family: var(--font);
}
.container-no-content-chat .text-empty-content .title {
  font-weight: 600;
  font-size: 17px;
  margin-bottom: 10px;
}

@media screen and (min-width: 768px) {
  .add-new-chat {
    display: block;
  }
  .container-no-content-chat ion-icon {
    height: 440px;
  }
}
.time {
  font-family: var(--font);
  font-weight: 300 !important;
  font-size: 10px;
}

.msg-read h2 {
  font-family: var(--font);
  font-weight: 600;
  color: var(--text-color-2nd-login-desktop);
}
.msg-read .last-msg {
  font-family: var(--font);
  font-weight: 300;
  color: #9D93C2;
}

.msg-not-read h2 {
  font-family: var(--font);
  font-weight: 700;
  color: var(--text-color-2nd-login-desktop);
}
.msg-not-read .last-msg {
  font-family: var(--font);
  font-weight: 700;
  color: var(--text-color-2nd-login-desktop);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/chat/chat-history/chat-history.page.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAGI;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AAAR;;AAIA;EACI,WAAA;EACA,YAAA;AADJ;AAGI;EACI,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AADR;AAEQ;EACI,WAAA;EACA,YAAA;AAAZ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AAFJ;AAII;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;AAFR;AAKI;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;AAHR;AAMI;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAJR;AAOI;EACI,eAAA;EACA,YAAA;AALR;;AAQA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;AALJ;;AAOA;EAEI,6BAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,UAAA;EACA,YAAA;AAJJ;;AAMA;EACI,aAAA;AAHJ;;AAKA;EACI,kBAAA;AAFJ;AAGI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,iBAAA;AAAR;AAEI;EACI,aAAA;EACA,WAAA;AAAR;AAEI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;AAAR;AACQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AACZ;;AAGA;EACI;IACI,cAAA;EAAN;EAGM;IACI,aAAA;EADV;AACF;AAIA;EACI,wBAAA;EAA0B,2BAAA;EAC1B,eAAA;AADJ;;AAII;EACI,wBAAA;EAA0B,gBAAA;EAC1B,0CAAA;AAAR;AAEI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,cAAA;AACR;;AAGI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,0CAAA;AACR;AACI;EACI,wBAAA;EAA0B,gBAAA;EAC1B,0CAAA;AAER","sourcesContent":[".mg {\n    margin-left: 6px;\n}\n\n.name {\n    font-weight: bold;\n    float: left;\n}\n\n.badge {\n    float: right;\n}\n\n.aling-all {\n    display: inline-flex;\n    align-items: center;\n    font-size: .8em;\n}\n\n.rm-mg {\n    margin-left: -80px;\n}\n\n.item-chat{\n    h2, p{\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n}\n\n.icon-avatar {\n    width: 60px;\n    height: 60px;\n    // margin-right: 20px;\n    .profile-picture{\n        background: var(--bg-color);\n        width: 60px;\n        height: 60px;\n        border-radius: 50%;\n        padding: 18px;\n        .cus-picture{\n            width: 24px;\n            height: 24px;\n        }\n    }\n}\n\n.new-message-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n    align-items: flex-start;\n    padding: 10px 0px;\n    width: 100%;\n\n    .chat-title {\n        margin-bottom: 5px;\n        font-size: 16px;\n        font-weight: bold;\n    }\n\n    .user-last-message-name {\n        font-size: 16px;\n        margin-bottom: 3px;\n        font-weight: bold;\n    }\n\n    .user-last-message {\n        font-size: 14px;\n        margin-bottom: 3px;\n        width: 90%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .user-last-message-date {\n        font-size: 10px;\n        opacity: 0.7;\n    }\n}\n.notif{\n    width: 13px;\n    height: 13px;\n    border-radius: 50%;\n    color: rgb(255 255 255 / 0);\n}\nion-searchbar{\n    //--background: var(--bg-color);\n    --icon-color: rgba(0,0,0,0.6);\n    font-family: var(--font); font-weight: 400;;\n    width: 90%;\n    margin: auto;\n}\n.add-new-chat{\n    display: none;\n}\n.container-no-content-chat{\n    position: relative;\n    >.wait-content{\n        position: absolute;\n        top: 15px;\n        left: 0;\n        width: 100%;\n        text-align: center;\n        font-family: var(--font); font-weight: 600;;\n        font-size: 1.3rem;\n    }\n    ion-icon{\n        height: 300px;\n        width: 100%;\n    }\n    .text-empty-content {\n        height: 70px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        margin: auto;\n        text-align: center;\n        font-family: var(--font);\n        .title{ \n            font-weight: 600;\n            font-size: 17px;\n            margin-bottom: 10px;\n        }\n    }\n}\n@media screen and (min-width: 768px) {\n    .add-new-chat{\n        display: block;\n    }\n    .container-no-content-chat{\n        ion-icon{\n            height: 440px;\n        }\n    }\n}\n.time{\n    font-family: var(--font); font-weight: 300 !important;\n    font-size: 10px;\n}\n.msg-read{\n    h2{\n        font-family: var(--font); font-weight: 600;;\n        color: var(--text-color-2nd-login-desktop);\n    }\n    .last-msg{\n        font-family: var(--font); font-weight: 300;;\n        color: #9D93C2;\n    }\n}\n.msg-not-read{\n    h2{\n        font-family: var(--font); font-weight: 700;;\n        color: var(--text-color-2nd-login-desktop);\n    }\n    .last-msg{\n        font-family: var(--font); font-weight: 700;;\n        color: var(--text-color-2nd-login-desktop);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
